import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate } from "react-router-dom";
import BarLoader from "react-spinners/BarLoader";
import "swiper/css";
import "./LiveTV.css";
import "videojs-contrib-quality-levels";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { LiveTVplayer } from "../../components/vidjs/mainPlayer";
import { GetLivetv } from "../../Model/Content";
import { Playstatus, Playtracking } from "../../Model/Player"; //Include Home
import { userprofile } from "../../Model/Users";
import { SVGIcons, ImgIcons, VirsionCheck } from "../../Helpers/Common";
import { isMobile } from "react-device-detect";
import $ from "jquery";
import { FreeMode, Pagination, Navigation } from "swiper";
import videojs from "video.js";
var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function LiveTV(props) {
  const playerRef = React.useRef();
  const [contentdata, setContent] = useState(0);
  const [dataloaded, setDataloaded] = useState(0);
  const navigate = useNavigate();
  var vidRef = useRef([]);
  const [player, setPlayer] = useState(undefined);
  const [visible, setVisible] = useState(false);
  const [isLive, setisLive] = useState(true);
  var Keywords;

  useEffect(() => {
    VirsionCheck().then((vcheckres) => {
      setisLive(JSON.parse(vcheckres.data).data.is_live_tv)
    })
    let data = {
      seesionID:localStorage.getItem("session_id"),
      userID:localStorage.getItem("userID")
    }
    userprofile(data).then((userDatares) => {
      const userData = JSON.parse(userDatares.data.message);
      if (!userData.success) {
        navigate("/createaccount");
      }
    });
    GetLivetv().then((res) => {
      if (res.data.message && res.data.message == "session_expired") {
        navigate("/createaccount");
      }

      var LiveTVdata = JSON.parse(res.data.message.body);

      if (LiveTVdata.contents) {
        setDataloaded(true);
        setContent(LiveTVdata);
      } else {
        setDataloaded(false);
      }
    });
  }, []);

  const formatAMPM = (date) => {
    var ss = new Date(date);
    let hours = ss.getUTCHours();

    let minutes = ss.getUTCMinutes();
    const ampm = hours >= 12 ? "pm" : "am";

    hours %= 12;
    hours = hours || 12;
    minutes = minutes < 10 ? `0${minutes}` : minutes;

    const strTime = `${hours}:${minutes} ${ampm}`;

    return strTime;
  };

  let clsebtn = () => {
    // setPlayer(false)
    window.location = "/live-tv";
  };

  let idleTimer = null;
  let idleState = false;

  function showFoo(time) {
    clearTimeout(idleTimer);
    if (idleState == true) {
      $("#div1").removeClass("inactive");
    }
    idleState = false;
    idleTimer = setTimeout(function () {
      $("#div1").addClass("inactive");
      idleState = true;
    }, time);
  }

  showFoo(2000);

  $(window).mousemove(function () {
    showFoo(2000);
  });

  if (dataloaded == false) {
    return (
      <div className="loader">
        <BarLoader color="#ff000f" />
      </div>
    );
  } else {
    if (contentdata.live_tv.keywords) {
      Keywords = contentdata.live_tv.keywords.split(",");
      Keywords = <div className="lBay">{Keywords[0]}</div>;
    }

    return (
      <>
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          key="1"
        >
          <Helmet>
            <title>DocuBay Live - Stream Documentaries 24/7 </title>
            <meta
              name="description"
              content="Stream the best documentaries on DocuBay Live TV.  With 24/7 streaming of the curated selection of documentary films and series from around the globe, you'll always have something new to discover. "
            />
            <meta name="keywords" content="" />
            <meta property="og:title" content="" />
          </Helmet>
          <div>
            <div className="bg-video-wrap dD-block">
              <video
                ref={(el) =>
                  (vidRef.current["ov" + contentdata.contents.ID] = el)
                }
                poster={contentdata.live_tv.mxplayer_landscape_banner.original}
                className="onhover live_tv_player"
                autoPlay
                id="mute"
              ></video>
            </div>
            {visible ? (
              <div id="LiveTVplayer">
                <LiveTVplayer
                  data={contentdata.live_tv.live_app_url}
                  subtitles={{}}
                  post={contentdata.live_tv.thumbnail_image2.small}
                  controls={false}
                  autoplay={true}
                  loader={true}
                  functionclose={clsebtn}
                />
              </div>
            ) : null}
            {!visible && (
              <div className="dD-none">
                <header>
                  <div className="mainNav fixed">
                    <div className="topQuestion">
                      <img
                        src={ImageData["live-red.png"]}
                        alt="help"
                        className="temp61-liveRed"
                      />
                    </div>
                  </div>
                </header>
                <main>
                  <section className="mb-0">
                    <div className="homeBanner">
                      <div className="innerBanner">
                        <picture>
                          <img
                            src={contentdata.live_tv.thumbnail_image2.medium}
                            alt="live"
                          />
                        </picture>
                        <div className="play-btn">
                          <img
                            src={SVGIcon["play.svg"]}
                            alt="DocuBay"
                            onClick={(e) => {
                              e.preventDefault();
                              setVisible(true);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </section>
                  <section className="mb-0">
                    <div className="temp61">
                      <div className="temp61-inn">
                        <div className="temp61-head">
                          <img
                            src={contentdata.live_tv.thumbnail_image2.small}
                            alt="Live"
                          />
                          <p>Now Playing</p>
                          <h5>{contentdata.live_tv.title}</h5>
                        </div>
                        <div className="temp61-headInn">
                          <div className="lBay lbg">
                            {contentdata.live_tv.content_category}{" "}
                            {contentdata.live_tv.age_restriction}
                          </div>
                          <div className="lBay">
                            {contentdata.live_tv.genres_assign[0].name}
                          </div>
                          {Keywords}
                        </div>
                      </div>
                    </div>
                  </section>
                  <section className="mb-0">
                    <div className="temp62">
                      {contentdata.contents.map((content, index) => {
                        var keywords = content.contents.keywords.split(",");
                        return (
                          <div className="temp62-inn" key={index}>
                            <div className="temp62-left">
                              <img
                                src={content.contents.vertical_banner.small}
                                alt=""
                              />
                            </div>
                            <div className="temp62-right">
                              <h5>{content.contents.title}</h5>
                              <h6>Starts at : {formatAMPM(content.date)}</h6>
                              <div className="temp62-rightInn">
                                <div className="lBay lbg">
                                  {content.contents.content_category}{" "}
                                  {content.contents.age_restriction}
                                </div>
                                <div className="lBay">
                                  {content.contents.genres_assign[0].name}
                                </div>
                                <div className="lBay">{keywords[0]}</div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      <div className="lastchild"></div>
                    </div>
                  </section>
                  <Mobilemenu active="3" isLive={isLive} />
                </main>
              </div>
            )}
            <div
              className="dD-block"
            // onLoad={() => (isDesktop ? liveLoad() : "")}
            >
              {!isMobile ? (
                <>
                  <LiveTVplayer
                    data={contentdata.live_tv.live_app_url}
                    subtitles={{}}
                    // post={contentdata.live_tv.thumbnail_image1.medium}
                    post={contentdata.live_tv.mxplayer_landscape_banner.original}
                    controls={false}
                    autoplay
                    // loader={true}
                    functionclose={clsebtn}
                    classname={"hidelive"}
                  />
                </>
              ) : null}

              <div className="live-header12">
                <img
                  src={ImageData["live-red.png"]}
                  alt="help"
                  className="live-right-icon"
                />
              </div>
              <main id="div1">
                <div className="live-header">
                  <Link to="/">
                    <div className="docubayBack white pl-8 left-arrow">
                      <img src="img/svg/back.svg" alt="DocuBay" />
                    </div>
                  </Link>
                </div>
                <div className="head-banner-live">
                  <div className="content-live1">Now Playing</div>
                  <div className="content-live2">
                    {contentdata.live_tv.title}
                  </div>
                  <div className="content-live3">
                    {contentdata.live_tv.genres_assign[0].name} & &nbsp;
                    {Keywords}
                  </div>
                </div>
                <section className="mb-0 dD-block bottom-content">
                  <div className="temp98 mb-0 dD-block">
                    <div className="head-layout1">
                      <h3>
                        Next <span className="red">Up</span>
                      </h3>
                    </div>
                    <div className="temp98-area">
                      <Swiper
                        navigation={{
                          prevEl: ".slick-prev",
                          nextEl: ".slick-next",
                        }}
                        slidesPerView={2.4}
                        spaceBetween={16}
                        freeMode={true}
                        loop={false}
                        roundLengths={true}
                        loopAdditionalSlides={30}
                        breakpoints={{
                          650: {
                            slidesPerView: 1,
                          },
                          850: {
                            slidesPerView: 3.1,
                          },
                        }}
                        modules={[FreeMode, Pagination, Navigation]}
                        className="temp98-slider"
                      >
                        <div className="side-overlay-L dD-block"></div>
                        <button
                          className="slick-prev slick-arrow"
                          type="button"
                        />
                        {contentdata.contents.map((content, index) => {
                          var keywords = content.contents.keywords.split(",");
                          return (
                            <SwiperSlide className="temp62-inn" key={index}>
                              <div className="temp62-left1">
                                <img
                                  src={content.contents.thumbnail_image2.small}
                                  alt=""
                                />
                              </div>
                              <div className="temp62-right1">
                                {/* <h5>{content.contents.title}</h5> */}
                                <h6>Playing at : {formatAMPM(content.date)}</h6>
                                <div className="temp62-rightInn1">
                                  <div className="lBay">
                                    {content.contents.genres_assign[0].name}
                                  </div>
                                  <div className="lBay">{keywords[0]}</div>
                                </div>
                              </div>
                            </SwiperSlide>
                          );
                        })}
                        <div className="side-overlay-R dD-block"></div>
                        <button
                          className="slick-next slick-arrow"
                          type="button"
                          aria-label="Next"
                        />
                      </Swiper>
                    </div>
                  </div>
                </section>
              </main>
            </div>
          </div>
        </motion.div>
      </>
    );
  }
}
